import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useDispatch } from "react-redux";
import { removeToast, revealToast, useUi } from "../store/ui";
import "./toasts.scss";

export default function Toasts() {
    const { toasts } = useUi();
    return createPortal(
        toasts.map(t => <Toast key={t.id} toast={t} />),
        document.getElementById("toasts")
    );
}

function Toast({ toast }) {
    const dispatch = useDispatch();
    useEffect(
        () => {
            let timeout;
            if (toast.revealing) {
                timeout = setTimeout(() => dispatch(removeToast(toast.id)), 2000);
            } else {
                timeout = setTimeout(() => dispatch(revealToast(toast.id)), 0);
            }
            () => cancelTimeout(timeout);
        },
        [toast]
    );
    return (
        <li className={toast.revealing ? "revealing" : null}>
            <span>{toast.message}</span>
        </li>
    );
}
